export const NotificationsState = _ => ({
  notificationsList: [],
  recentUnreadNotifications: [],
  totalNotificationsCount: 0,
  unreadNotificationsCount: 0,
})
